import { Badge } from '@signozhq/ui/badge';
import styled from 'styled-components';

export const StyledText = styled.span`
	cursor: pointer;
`;

export const StyledTag = styled(Badge)`
	margin-top: 0.125rem;
	margin-bottom: 0.125rem;
	padding-left: 0.5rem;
	display: flex;
`;
